export default __webpack_public_path__ + "static/media/click.24e6e10d.wav";